style= require('./lineup-controls.styl')
ft-button(success, disabled=isDisabled, (click)=this.submit(match)) Submit
